import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUserDataSyncMachinesService = ( createDecorator('IUserDataSyncMachinesService'));
export { IUserDataSyncMachinesService };
